/**
 *
 * Deckable 2
 *
 * This is the second version of deckable that uses greensock
 */


const $ = require('jquery');
const _throttled = require('../_debounce');

const { TimelineMax, TweenLite, Power4, Elastic } = window;


class Deckable2 {

  constructor(el, options) {
    this.$el     = $(el );
    this.$container = this.$el.find('.deckable2__container');
    this.$decks   = this.$el.find('.deckable2__deck');
    this.$loading   = this.$el.find('.deckable__loading');

    this.initialDeck   = null;
    this.activeEl     = null;
    this.active     = null;

    this.previous     = null;
    this.previousEl   = null;
    this.duration     = 1;
    this.maxHeight      = null;
    this.animation     = new TimelineMax();

    this.defaults     = {
      activeClass: 'deckable2-is-active',
      nextDeckEl: '.deckable2--nextDeck',
      previousDeckEl: '.deckable2--previousDeck'
    };

    // @todo one day we should build out settings for this plugin
    this.settings = $.extend({}, this.defaults, (typeof options === "object" ? options : {}));

    new TimelineMax()
      .set( this.$decks, { xPercent: '100%'} )
      .call( ()=>{
        this.$container.addClass('deckable2--initialized');
      } );

    //created a function to set the height of the container, but decided to remove this because
    //it's probably ok for the height of each deck to adjust the painter
    this.active = this.getActiveDeck();
    this.events();

  }

  goToPreviousDeck(event){

    if (event && typeof event !== 'undefined') {
      event.preventDefault();
    }

    if( !(this.activeEl) ){
      return;
    }

    const previousEl = this.activeEl.prev();
    const prevDeck  = previousEl.data('deckable2');

    if( previousEl && previousEl.hasClass('deckable2__deck') && prevDeck ){

      this.goToDeck( prevDeck );

    }

  }

  goToNextDeck(event){

    if (event && typeof event !== 'undefined') {
      event.preventDefault();
    }

    if( !(this.activeEl) ){
      return;
    }

    const nextEl = this.activeEl.next();
    const nextDeck = nextEl.data('deckable2');

    if( nextEl && nextEl.hasClass( 'deckable2__deck' ) && nextDeck ){

      this.goToDeck( nextDeck );
    }

  }

  setContainerHeight(){
    this.maxHeight = Math.max.apply( null, this.$decks.map( function(){
      return $(this).outerHeight() || 0;
    } ).get() );

    try{
      this.$el.css( 'minHeight', this.maxHeight );
    }catch(e){

      console.log( e );
      this.$el.css( 'minHeight', this.$decks.first().outerHeight() || 0 );
    }


  }

  events(){
    $(window).on( 'resize', _throttled(150, this.event__resizeContainer.bind(this) ) );

    $( this.settings.nextDeckEl ).on( 'click', this.goToNextDeck.bind(this) );
    $( this.settings.previousDeckEl ).on( 'click', this.goToPreviousDeck.bind(this) );

  }

  event__resizeContainer(event, newSize, oldSize){
    try{
      TweenLite
        .set(this.$container,{minHeight: this.activeEl.outerHeight() || 0});
    }catch (e) {
      TweenLite
        .set(this.$container,{ minHeight: this.$decks.first().outerHeight() || 0});
    }

  }

  getActiveDeck() {
    return this.$decks.filter($(`.${this.settings.activeClass}`));

  }

  getDeckByAttr(deckAttr) {

    return this.$decks.find(`[data-deckable2="${deckAttr}"]`);

  }

  hideAllDecks() {

    if (this.animation && this.animation.isActive()) {
      this.animation.kill();
    }

    //update important variables for keeping track of selections
    this.previousEl = this.activeEl;
    this.previous = this.active;

    this.animateOut();
    //unset the focus of any elements selected
    document.activeElement.blur();

    return this;
  }

  goToDeck(deckAttr) {

    if (typeof deckAttr === 'undefined' || deckAttr === this.active || deckAttr === "") {
      return;
    }

    if (this.animation && this.animation.isActive()) {
      this.animation.kill();
    }

    //update important variables for keeping track of selections
    this.previousEl = this.activeEl;
    this.previous = this.active;

    this.activeEl = this.$el.find(`[data-deckable2='${deckAttr}']`);
    this.active = deckAttr;

    this.animation = new TimelineMax();

    if( this.activeEl ){
      //fire events
      this.animateOut();
      // this.showHideLoading(false );
      this.animateIn();

      // Force webinar video repaint to scale to the container size.
      // There is a CSS bug that prevents the video from filling
      // the size when rendered off-screen in combination with TimelineMax.
      // The fix is inspired by https://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes/3485654#3485654
      // If this is removed, the video will render clipped on initial confirmation open.
      if (deckAttr === 'confirmation') {
        const video = this.$el.find('[data-deckable2="confirmation"] video');
        if (video.length) {
          let retries = 0;
          const i = setInterval(() => {
            video[0].style.display = 'none';
            video[0].offsetHeight; // This line is not a mistake. It is necessary for the repaint to happen!
            video[0].style.display = '';

            if (retries > 120) {
              clearInterval(i); // We are going to try only for about 30 seconds!
            }

            retries++;
          }, 300);
        }
      }
    }

    return this;

  }

  animateOut() {
    //slideout the old deck
    if (this.previousEl) {

      this.animation
        .addLabel('animateOut')
        .to( this.previousEl, .2, { skewX:-2}, 'animateOut' )
        .to( this.previousEl, (this.duration - .5), { xPercent : '-107%', ease: Power4.easeInOut }, 'animateOut' )
        .call( ()=>{

          this.showHideLoading(true);

          //remove classes
          this.previousEl
            .removeClass(`${this.settings.activeClass}`);

          //fire off any events listening to this action
          this.$el.trigger(`deckable/animateOut/${this.previous}`, [this.previousEl, this.previous]);

        });

    }

    return this;
  }

  animateIn() {

    if( this.previousEl ){
      this.animation
        .set( this.$container, {minHeight: this.previousEl.outerHeight() || 0 } );
    }

    this.animation
    //set the height of the container to the height of the active el
      .addLabel('animateIn')
      .to( this.$container, .25, {minHeight : (this.activeEl.outerHeight() || 0) + 3})
      //move the active el to the right side
      .set(this.activeEl, {xPercent: '100%', skewX:0 } )
      //slide in new Deck
      .call( ()=>{
        this.showHideLoading(false);
      } )
      .to(this.activeEl, this.duration, {xPercent: 0, ease: Elastic.easeInOut})
      .call( ()=>{
        this.activeEl.addClass(`${this.settings.activeClass}`);

        this.$el.trigger( `deckable/animateIn/${this.active}`, [this.activeEl, this.active]);
      } );

    return this;

  }

  showHideLoading(bool) {
    switch (bool) {
      //if true, then show the laoding
      case true:
        this.$loading.removeClass('itbl-u-display-none');
        break;
      //if false, then hide the loading
      case false:
        this.$loading.addClass('itbl-u-display-none');
        break;
      //default is to toggle the hide/show class
      default:
        this.loadingSpinnerState = !this.loadingSpinnerState;

    }

    return this;
  }

}

module.exports = Deckable2;
